<div class="chat-suggestions" role="group" [attr.aria-label]="'chatAi.suggestions.ariaLabel' | translate">

  <!-- Data query chips -->
  <p class="chat-suggestions__title">{{ 'chatAi.suggestions.title' | translate }}</p>

  <div class="chat-suggestions__chips">
    <button type="button"
            class="chat-suggestions__chip"
            *ngFor="let chip of chips; trackBy: trackByIndex"
            (click)="onPick(chip.promptI18nKey)">
      {{ chip.i18nKey | translate }}
    </button>
  </div>

  <!-- Navigation shortcuts -->
  <p class="chat-suggestions__title chat-suggestions__title--nav">{{ 'chatAi.suggestions.navTitle' | translate }}</p>

  <div class="chat-suggestions__chips">
    <!-- Agenda -->
    <button type="button"
            class="chat-suggestions__chip chat-suggestions__chip--nav"
            (click)="onNavigate('/calendar')">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
      {{ 'chatAi.suggestions.goToAgenda.label' | translate }}
      <svg class="chat-suggestions__arrow" width="11" height="11" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.5"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    </button>

    <!-- Kanban -->
    <button type="button"
            class="chat-suggestions__chip chat-suggestions__chip--nav"
            (click)="onNavigate('/kanban')">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <rect x="3" y="3" width="5" height="18" rx="1"/>
        <rect x="10" y="3" width="5" height="12" rx="1"/>
        <rect x="17" y="3" width="5" height="15" rx="1"/>
      </svg>
      {{ 'chatAi.suggestions.goToKanban.label' | translate }}
      <svg class="chat-suggestions__arrow" width="11" height="11" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.5"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    </button>
  </div>

</div>
